<template>
  <form>
    <v-text-field
      v-model="name"
      :error-messages="nameErrors"
      :counter="50"
      :label="$t('users.name')"
      required
      @input="$v.name.$touch()"
      @blur="$v.name.$touch()"
    />
    <v-text-field
      v-model="email"
      :error-messages="emailErrors"
      :label="$t('users.email')"
      required
      @input="$v.email.$touch()"
      @blur="$v.email.$touch()"
    />
    <v-text-field
      autocomplete="new-password"
      v-model="password"
      :error-messages="passwordErrors"
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :type="showPassword ? 'text' : 'password'"
      :label="$t('users.password')"
      @click:append="showPassword = !showPassword"
      @input="$v.password.$touch()"
      @blur="$v.password.$touch()"
    />
    <v-text-field
      v-model="repeatPassword"
      :error-messages="repeatPasswordErrors"
      :append-icon="showRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :type="showRepeatPassword ? 'text' : 'password'"
      :label="$t('users.repeatPassword')"
      @click:append="showRepeatPassword = !showRepeatPassword"
      @input="$v.repeatPassword.$touch()"
      @blur="$v.repeatPassword.$touch()"
    />
    <v-checkbox
      v-model="isSuperUser"
      :label="$t('users.isSuperUser')"
      required
    />
    <v-checkbox
      v-model="notification"
      :label="$t('users.notification')"
      required
    />
    <v-autocomplete
      v-if="!isSuperUser && enterprises.length > 0"
      v-model="selectedEnterprises"
      :items="enterprises"
      :filter="handleCustomFilter"
      :label="$t('users.enterprises')"
      item-text="Name"
      item-value="ID"
      multiple
    />
    <v-select
      v-if="!isSuperUser && selectedEnterprises.length > 0"
      v-model="defaultEnterprise"
      :items="listEnterpriseSelected"
      :label="$t('users.defaultEnterprise')"
      item-text="Name"
      item-value="ID"
    />
    <!-- <v-container fluid>
      {{ $t('users.permissions.title') }}:
      <v-layout wrap>
        <v-flex
          xs6
          md4
          v-for="(item, index) in userPermissions"
          :key="`userPermission${index}`"
        >
          <v-checkbox
            v-model="permission"
            :color="enterpriseColor"
            :label="$t(`users.permissions.${item.name}`)"
            :value="item.id"
            :append-icon="item.icon"
          />
        </v-flex>
      </v-layout>
    </v-container> -->
    <div
      class="text-right pt-2"
    >
      <v-btn v-if="!isNew" color="red darken-1" dark class="mr-4" @click="showConfirmDelete = !showConfirmDelete">{{ $t('common.delete') }}</v-btn>
      <v-btn class="mr-4" @click="handleClear">{{ $t('common.cancel') }}</v-btn>
      <v-btn dark :color="enterpriseColor" @click="handleSubmit">{{ $t('common.save') }}</v-btn>
    </div>
    <confirm-delete 
      :showDialog="showConfirmDelete"
      :onKO="handleCancelDelete"
      :onOK="handleDelete"
    />
  </form>
</template>

<script>
  import api from '@/services/api'
  import constants from '@/constants'
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, email, sameAs } from 'vuelidate/lib/validators'
  import * as sha1 from 'js-sha1'
  import ConfirmDelete from '@/components/ConfirmDelete'

  export default {
    mixins: [validationMixin],
    components: {
      ConfirmDelete
    },
    props: {
      data: {
        type: Object,
        required: false,
        default: null
      },
      onDelete: {
        type: Function,
        required: true
      },
      onSave: {
        type: Function,
        required: true
      },
      onCancel: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      name: '',
      email: '',
      showPassword: false,
      showRepeatPassword: false,
      password: '',
      repeatPassword: '',
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      isSuperUser: false,
      notification: false,
      selectedEnterprises: [],
      enterprises: [],
      showConfirmDelete: false,
      defaultEnterprise: null,
      permission: []
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      userPermissions () {
        return constants.userPermission
      },
      listEnterpriseSelected () {
        return this.enterprises.filter(x => this.selectedEnterprises.indexOf(x.ID) >=0)
      },
      isNew () {
        return this.$route.params.id === 'new'
      },
      passwordErrors () {
        const errors = []
        if (this.$v.password) {
          if (!this.$v.password.$dirty) return errors
          !this.$v.password.required && errors.push(this.$t('users.messages.passwordRequired'))          
        }
        return errors
      },
      repeatPasswordErrors () {
        const errors = []
        if (!this.$v.repeatPassword.$dirty) return errors
        !this.$v.repeatPassword.sameAsPassword && errors.push(this.$t('users.messages.sameAsPassword'))
        return errors
      },
      // checkboxErrors () {
      //   const errors = []
      //   if (!this.$v.checkbox.$dirty) return errors
      //   !this.$v.checkbox.checked && errors.push('You must agree to continue!')
      //   return errors
      // },
      // selectErrors () {
      //   const errors = []
      //   if (!this.$v.select.$dirty) return errors
      //   !this.$v.select.required && errors.push('Item is required')
      //   return errors
      // },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push(this.$t('users.messages.nameMostCharacters'))
        !this.$v.name.required && errors.push(this.$t('users.messages.nameRequired'))
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push(this.$t('users.messages.emailValid'))
        !this.$v.email.required && errors.push(this.$t('users.messages.emailRequired'))
        return errors
      },
    },
    watch: {
      // data (v) {
      //   this.name = this.data && this.data.Name ? this.data.Name : ''
      //   this.email = this.data && this.data.Email ? this.data.Email : ''
      //   this.isSuperUser = this.data && this.data.Role === constants.roles.admin ? true : false
      //   this.selectedEnterprises = this.data && this.data.Enterprises ? this.data.Enterprises : []
      //   this.defaultEnterprise = this.data && this.data.EnterpriseDefault ? this.data.EnterpriseDefault : null
      // },
      'data.Name' (v) {
        if (v) this.name = v
      },
      'data.Email' (v) {
        if (v) this.email = v
      },
      'data.Role' (v) {
        if (v) this.isSuperUser = v === constants.roles.admin ? true : false
      },
      'data.Enterprises' (v) {
        if (v) this.selectedEnterprises = v
      },
      'data.EnterpriseDefault' (v) {
        if (v) this.defaultEnterprise = v
      },
      'data.Permission' (v) {
        if (v) this.permission = v
      },
      'data.Notification' (v) {
        if (v) this.notification = v === 1 ? true : false
      },
    },
    validations () { 
      if (this.isNew) {
        return {
          name: { required, maxLength: maxLength(50) },
          email: { required, email },
          password: { required },
          repeatPassword: {
            sameAsPassword: sameAs('password')
          }
        }
      } else {
        return {
          name: { required, maxLength: maxLength(50) },
          email: { required, email },
          repeatPassword: {
            sameAsPassword: sameAs('password')
          }
        }
      }
    },
    mounted () {
      this.getEnterprises()
      this.name = this.data && this.data.Name ? this.data.Name : ''
      this.email = this.data && this.data.Email ? this.data.Email : ''
      this.permission = this.data && this.data.Permission ? this.data.Permission : []
    },
    methods: {
      getEnterprises () {
        api.getAll('enterprises', true, 1, 100000, '').then(response => {
          this.enterprises = response.data
        })
      },
      handleCustomFilter (item, queryText) {
        const textOne = item.Name.toLowerCase()
        const searchText = queryText ? queryText.toLowerCase() : ''

        return textOne.indexOf(searchText) > -1
      },
      handleSubmit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          const body = {
            Name: this.name,
            Email: this.email,
            Role: this.isSuperUser ? constants.roles.admin : constants.roles.normal,
            Password: this.password ? sha1(this.password) : null,
            Enterprises: !this.isSuperUser ? this.selectedEnterprises : [],
            Permission: this.permission,
            Notification: this.notification,
            EnterpriseDefault: !this.isSuperUser && this.defaultEnterprise && this.selectedEnterprises.indexOf(this.defaultEnterprise) >= 0 ? this.defaultEnterprise : !this.isSuperUser && this.selectedEnterprises.length > 0 ? this.selectedEnterprises[0] : null
          }
          this.onSave(body)
        }

      },
      handleCancelDelete() {
        this.showConfirmDelete = false
      },
      handleDelete () {
        this.showConfirmDelete = false
        this.onDelete()
      },
      handleClear () {
        this.$v.$reset()
        this.name = ''
        this.email = ''
        this.select = null
        this.isSuperUser = false
        this.onCancel()
      },
    },
  }
</script>
